import { RouteRecordRaw } from 'vue-router';

import { ROLES } from '@/constants/roles';
import { ACTIONS_OF_USERS } from '@/modules/actions-of-users/routes';
import { BANK_ACCOUNTS } from '@/modules/bank-accounts/routes';
import { CONTRACTS_OLD } from '@/modules/contracts-old/routes';
import { CURRENCIES } from '@/modules/currency/routes';
import { IDENTIFICATION } from '@/modules/identification/routes';
import { ONBOARDING_SOLE_TRADER } from '@/modules/onboarding-dashboard/SoleTrader/routes';
import { ONBOARDING_PERSONAL } from '@/modules/onboarding-personal-profile/routes';
import { ONBOARDING_USERS } from '@/modules/onboarding-user-profile/routes';
import { PROFILE } from '@/modules/profile-settings/routes';
import { SYSTEM_OPERATIONS } from '@/modules/system-operations/routes';
import { TOP_UP } from '@/modules/top-up/routes';
import { TRANSACTIONS } from '@/modules/transactions-old/routes';
import { USER_PROFILE } from '@/modules/user-profile/routes';
import { USERS } from '@/modules/users/routes';
import { WITHDRAWAL } from '@/modules/withdrawal/routes';
import { checkPermission } from '@/router/middlewares/permissionGuard';

const BaseLayout = () => import('@/layouts/base-layout.vue');

// @ts-ignore
export const DASHBOARD_ROUTES: RouteRecordRaw[] = [
  ONBOARDING_USERS,
  ONBOARDING_PERSONAL,
  ONBOARDING_SOLE_TRADER,
  USERS,
  ACTIONS_OF_USERS,
  CONTRACTS_OLD,
  TRANSACTIONS,
  CURRENCIES,
  SYSTEM_OPERATIONS,
  PROFILE,
  ...USER_PROFILE,
  IDENTIFICATION,
  WITHDRAWAL,
  TOP_UP,
  BANK_ACCOUNTS,
];

const checkAvailableRoute = (route: RouteRecordRaw): boolean => {
  if (!route.meta?.root) return false;

  return checkPermission(route.meta?.permission);
};

export const getAvailableDashboardRoutes = (routes: RouteRecordRaw[] = DASHBOARD_ROUTES): RouteRecordRaw[] => (
  routes.filter((route: RouteRecordRaw) => {
    if (route.children) {
      route.children = getAvailableDashboardRoutes(route.children);
    }

    return checkAvailableRoute(route);
  })
);

export const DASHBOARD: RouteRecordRaw = {
  path: '/dashboard',
  name: 'dashboard',
  component: BaseLayout,
  redirect() {
    const availableRoutes = getAvailableDashboardRoutes();
    const [firstRoute] = availableRoutes;

    return firstRoute || { name: 'sign-in-manual' };
  },
  meta: {
    permission: (role) => role !== ROLES.merchant,
  },
  children: DASHBOARD_ROUTES,
};

export default DASHBOARD_ROUTES;
